import { render } from "./ReferralStatus.vue?vue&type=template&id=ff3a5322&lang=pug"
import script from "./ReferralStatus.vue?vue&type=script&lang=js"
export * from "./ReferralStatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__